var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PrimaryMarket_IPO, PrimaryMarket_IPO_ADD_MSG, PrimaryMarket_IPO_CLEAR_MSG, PrimaryMarket_IPO_ERROR, PrimaryMarket_IPO_HIDE_ERROR, PrimaryMarket_IPO_START_LOADER, PrimaryMarket_IPO_STOP_LOADER, UPDATE_UPCOMING_DATA, } from "../interface/iPrimaryMarketIpo";
var initState = {
    data: {
        OngoingIPO: [],
        UpcomingIPO: [],
        AboutListIPO: [],
        ListedIPO: [],
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: "",
        show: false,
        icon: "",
    },
};
var PrimaryMarketIpoReducer = function (state, action) {
    if (state === void 0) { state = initState; }
    var handleUpcomingData = function (data, alerts) {
        var _a;
        var temp = (_a = data === null || data === void 0 ? void 0 : data.UpcomingIPO) === null || _a === void 0 ? void 0 : _a.map(function (el) {
            var found = alerts === null || alerts === void 0 ? void 0 : alerts.find(function (val) {
                return (val === null || val === void 0 ? void 0 : val.sym) === (el === null || el === void 0 ? void 0 : el.nse_Symbol) ||
                    (val === null || val === void 0 ? void 0 : val.sym) === (el === null || el === void 0 ? void 0 : el.bse_Symbol) ||
                    (val === null || val === void 0 ? void 0 : val.sym) === (el === null || el === void 0 ? void 0 : el.symbol);
            });
            return found ? __assign(__assign({}, el), { alert: true }) : __assign(__assign({}, el), { alert: false });
        });
        return __assign(__assign({}, data), { UpcomingIPO: temp });
    };
    switch (action.type) {
        case PrimaryMarket_IPO:
            return __assign(__assign({}, state), { data: action.payload.data });
        case PrimaryMarket_IPO_ADD_MSG:
            return __assign(__assign({}, state), { message: action.payload.message });
        case PrimaryMarket_IPO_CLEAR_MSG:
            return __assign(__assign({}, state), { message: initState.message });
        case PrimaryMarket_IPO_ERROR:
            return __assign(__assign({}, state), { errorData: action.payload.errorData });
        case PrimaryMarket_IPO_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: initState.errorData });
        case PrimaryMarket_IPO_START_LOADER:
            return __assign(__assign({}, state), { loader: true });
        case PrimaryMarket_IPO_STOP_LOADER:
            return __assign(__assign({}, state), { loader: false });
        case UPDATE_UPCOMING_DATA:
            return __assign(__assign({}, state), { data: handleUpcomingData(state.data, action.payload.alerts) });
        default:
            return __assign({}, state);
    }
};
export default PrimaryMarketIpoReducer;
